module.exports = __webpack_public_path__ + "media/images/img_service_online-e0ce1dc3a0c71695245a83bc83ace02a.png";